var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewPaymentWithBackgroundCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FCF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 24L24.3333 20M24.3333 20L20.3333 16M24.3333 20H16.3333M30.3333 20C30.3333 25.5228 25.8561 30 20.3333 30C14.8104 30 10.3333 25.5228 10.3333 20C10.3333 14.4772 14.8104 10 20.3333 10C25.8561 10 30.3333 14.4772 30.3333 20Z",
    stroke: "#8F27C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewPaymentWithBackgroundCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new-payment-with-background-card-icon.6fdfd9e18d7ebbc784d91ac6398104c9.svg";